
const authStore = {
    isLoggedIn: true,
    userDetails: {},
    token: {},
    menuItems: {},
    orgId: '',
    sellerCreation: false,
    accountType: 'user',
    buyNow: [],
    accountDetails: {},
    region: {},
    flawFilter: [],
    occupationFilter: [],
    zodiacSignFilter: [],
    statusFilter: [],
    countApi: 0,
    initialLoadingFilter: false,
    educationList: [],
    fullEducations: [],
    zodiacSigns: [],
    flaws: [],
    status: [],
    occupation: [],
    allStars: [],
    fullOccupations: [],
    tEducationList: [],
    tFlaws: [],
    tStatus: [],
    tOccupation: [],
    dhisa: [],
    tDhisa:[],
    searchValue: '',
    minAge : 0,
    maxAge : 0,
    searchCount:0,
    fetchUserDetails :0,
    mobileFilter:false
}

export default authStore